// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__21Np-","emails":"CreateEditClinics_emails__1Z1tM","emailTagLabel":"CreateEditClinics_emailTagLabel__1EtVm"};